import { render, staticRenderFns } from "./SignupResetPasswordLayout.vue?vue&type=template&id=5b477fa4&scoped=true"
import script from "./SignupResetPasswordLayout.vue?vue&type=script&lang=ts"
export * from "./SignupResetPasswordLayout.vue?vue&type=script&lang=ts"
import style0 from "./SignupResetPasswordLayout.vue?vue&type=style&index=0&id=5b477fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b477fa4",
  null
  
)

export default component.exports